import ApprovalWorkflowSummary from './ApprovalWorkflowSummary';
import HITLReviewWorkbench from './HITLReviewWorkbench';
import { PolicyEngine } from './PolicyEngine';
import KillSwitchPanel from './KillSwitchPanel';
import { Users } from 'lucide-react';

// Dedicated Human-in-the-Loop review surface — approval pipeline,
// per-output review actions, policy rules, and the platform-wide AI
// kill switch. Separate from the Governance analysis areas (Signals,
// Risks, Dependencies, Actions Required, Decisions, Audit Trail).
const HITLGovernanceView = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
          <Users className="w-5 h-5 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-foreground">HITL Review Workbench</h1>
          <p className="text-sm text-muted-foreground">
            Human-in-the-loop oversight: approval workflow · review workbench · policy rules · kill switch
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-6">
          <ApprovalWorkflowSummary />
          <HITLReviewWorkbench />
          <PolicyEngine />
        </div>
        <div className="space-y-6">
          <KillSwitchPanel />
        </div>
      </div>
    </div>
  );
};

export default HITLGovernanceView;
